import { travelerPartnerLogos } from '~/content/traveler';
import { cn } from '~/lib/cn';

/** Grey partner logo strip under the traveler intro copy (Figma 1287:50727). */
export function TravelerPartnerLogos() {
  return (
    <ul className="flex items-center gap-5 md:gap-[25px]">
      {travelerPartnerLogos.map((logo) => (
        <li key={logo.name} className={cn('shrink-0', logo.desktopOnly && 'max-md:hidden')}>
          <img
            src={logo.src}
            alt={logo.name}
            width={logo.width}
            height={logo.height}
            loading="lazy"
            decoding="async"
            style={{ width: logo.width, height: logo.height }}
            className="block max-w-none"
          />
        </li>
      ))}
    </ul>
  );
}
